import React from "react";
import { formatDate } from "@/lib/utils2";
import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  open: "bg-brand-dough/25 text-brand-ink",
  in_progress: "bg-brand/15 text-brand",
  resolved: "bg-brand/15 text-brand",
  approved: "bg-brand/15 text-brand",
  denied: "bg-brand-terracotta/15 text-brand-terracotta",
};

const STATUS_LABELS = {
  open: "Open", in_progress: "In progress", resolved: "Resolved", approved: "Approved", denied: "Denied",
};

export default function TicketCard({ ticket }) {
  return (
    <div className="rounded-2xl border border-brand-line bg-white p-6 card-shadow" data-testid="ticket-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="font-display text-2xl text-brand-ink">{ticket.case_number}</p>
          <p className="text-sm text-brand-muted mt-0.5">Opened {formatDate(ticket.created_at)}</p>
        </div>
        <Badge className={`rounded-full border-0 ${STATUS_STYLES[ticket.status] || ""}`}>{STATUS_LABELS[ticket.status] || ticket.status}</Badge>
      </div>
      <div className="mt-4">
        <p className="font-semibold text-brand-ink">{ticket.subject}</p>
        {ticket.message && <p className="text-brand-muted mt-1 leading-relaxed">{ticket.message}</p>}
      </div>
      {ticket.ticket_type === "cafe_registration" && (
        <div className="mt-3 text-sm text-brand-muted">
          Account request: {ticket.first_name} {ticket.last_name} · Store {ticket.store_number}
        </div>
      )}
      {ticket.notes && ticket.notes.length > 0 && (
        <div className="mt-4 pt-4 border-t border-brand-line space-y-3">
          <p className="text-xs uppercase tracking-widest text-brand-muted">Updates</p>
          {ticket.notes.map((n, i) => (
            <div key={i} className="text-sm">
              <p className="text-brand-ink">{n.text}</p>
              <p className="text-xs text-brand-muted mt-0.5">{n.author} · {formatDate(n.at)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
